import * as Cookies from "js-cookie";
import * as React from "react";
import { Redirect } from "react-router-dom";
import app from "../../core/application";
import * as Constants from "../../core/constants";
import { sendRequest } from "../../helpers/ajax";
import IAuthenticationRequest from "../../types/IAuthenticationRequest";
import IAuthenticationResponse from "../../types/IAuthenticationResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import Login from "./Login";

interface ILoginContainerProps {
    onLogin: (userSession: IUserSession) => void;
}

interface ILoginContainerState {
    isLoggedIn: boolean;
    formLoginProcessing: boolean;
    tokenLoginProcessing: boolean;
    loginFailed: boolean;
    redirectUrl: string;
}

class LoginContainer extends React.Component<ILoginContainerProps, ILoginContainerState>{

    constructor(props: ILoginContainerProps) {
        super(props);

        this.state = {
            isLoggedIn: false, formLoginProcessing: false, tokenLoginProcessing: false,
            loginFailed: false, redirectUrl: "/dashboard"
        };

        this.attemptLoginWithToken = this.attemptLoginWithToken.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public componentDidMount() {
        this.attemptLoginWithToken();
    }

    public render() {
        if (this.state.isLoggedIn) {
            return <Redirect to={this.state.redirectUrl} />;
        }
        return (
            <Login onSubmit={this.onSubmit} loginFailed={this.state.loginFailed} 
                formLoginProcessing={this.state.formLoginProcessing} 
                tokenLoginProcessing={this.state.tokenLoginProcessing} />
        );
    }

    private async onSubmit(email: string, password: string): Promise<void> {

        this.setState({ formLoginProcessing: true });

        const data: IAuthenticationRequest = { email, password };
        const response = await sendRequest<IResponse<IAuthenticationResponse>>("/api/authentication/authenticateuser", "POST", data);

        this.setState({ formLoginProcessing: false });

        if (response) {
            const auth = response.payload;
            if (auth.success) {

                // TODO: Must reset password scenario

                app().logInUser(auth.userSession);
                this.props.onLogin(auth.userSession);
                this.setState({ isLoggedIn: true });
            } else {
                this.setState({ loginFailed: true });
            }
        }
    }

    private async attemptLoginWithToken() {

        const authCookie = Cookies.get(Constants.COOKIE_AUTHTOKEN);

        if (authCookie) {

            this.setState({ tokenLoginProcessing: true });

            const application = app();

            const loggedInWithToken = await application.logInWithToken(authCookie);

            if (loggedInWithToken && application.userSession) {

                const session = application.userSession;

                if (session) {
                    let redirectUrl = "/";
                    const fromQS = "?from=";
                    if (window.location.search.indexOf(fromQS) === 0) {
                        redirectUrl = window.location.search.replace(fromQS, "");
                    }
                    this.props.onLogin(session);
                    this.setState({ redirectUrl, isLoggedIn: true });
                }
            } else {
                this.setState({ tokenLoginProcessing: false });
            }
        }
    }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/Login/LoginContainer.tsx